import { useCallback as e, useEffect as t } from "react";
import { useSWRConfig as n } from "swr";
//#region src/hooks/use-revalidate-modules.ts
var r = /* @__PURE__ */ new Set(), i = (e) => JSON.stringify(typeof e == "function" ? e() : e), a = (e) => {
	let n = i(e);
	t(() => (r.add(n), () => {
		r.delete(n);
	}), [n]);
}, o = () => {
	let { mutate: t, cache: a } = n();
	return { revalidateModules: e(async (e, n = !1) => {
		let o = (e) => n || !r.has(i(e)), s = Array.from(a.keys());
		for (let n of s) typeof n == "string" && n.startsWith("$inf$") && e.some((e) => n.includes(e)) && await t(n);
		await t((t) => Array.isArray(t) ? t.some((t) => e.includes(t)) && o(t) : !1, void 0), await t((t) => Array.isArray(t) ? t.some((t) => e.includes(t)) && !o(t) : !1);
	}, [a, t]) };
};
//#endregion
export { o as useRevalidateModules, a as useTrackedSWRKey };
